import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { ChatInternalService } from '../../../services/chat-internal.service';
import { M_ChatInternalPreferences } from '../../../models/M_ChatInternal';
import { SnackService } from '../../../services/snack.service';

@Component({
  selector: 'app-chat-internal-preferences',
  templateUrl: './chat-internal-preferences.component.html',
  styleUrls: ['./chat-internal-preferences.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatIconButton, MatButtonModule],
})
export class ChatInternalPreferencesComponent implements OnInit {
  open = false;

  prefs: M_ChatInternalPreferences = {
    nivel_detalle: 'medio',
    contexto_rol: '',
  };

  detailLevels = [
    { value: 'breve', label: 'Breve' },
    { value: 'medio', label: 'Medio' },
    { value: 'detallado', label: 'Detallado' },
  ];

  private chatService = inject(ChatInternalService);
  private snack = inject(SnackService);

  ngOnInit(): void {
    this.loadPreferences();
  }

  loadPreferences(): void {
    this.chatService.getPreferences().subscribe({
      next: (r) => {
        this.prefs = r.data;
      },
    });
  }

  toggle(): void {
    this.open = !this.open;
  }

  save(): void {
    this.chatService.updatePreferences(this.prefs).subscribe({
      next: (r) => {
        this.prefs = r.data;
        this.open = false;
        this.snack.show('Preferencias guardadas');
      },
    });
  }
}
